import { useEffect, useState } from "react";
const useWindowScroll = ()=>{
    const [windowOffset, setWindowOffset] = useState({
        x: undefined,
        y: undefined
    });
    useEffect(()=>{
        function handleWindowOffset() {
            setWindowOffset({
                x: window.scrollX,
                y: window.scrollY
            });
        }
        window.addEventListener("onscroll", handleWindowOffset);
        // This gets called once on initial load of this hooks
        // to set the initial window size dimensions.
        handleWindowOffset();
        return ()=>window.removeEventListener("onscroll", handleWindowOffset);
    }, []);
    return windowOffset;
};
export default useWindowScroll;
